// 文件与附件：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 文件预览
export const preview = Object.freeze({
  "filePreview.dialog": "File preview",
  "filePreview.interactionMode": "Preview interaction mode",
  "filePreview.contentModeHint": "Use the file's own controls in {mode} mode",
  "filePreview.globalDragHint":
    "Drag within the content area to move the preview window",
  "filePreview.globalDrag": "Drag window",
  "filePreview.close": "Close file preview",
  "filePreview.previous": "Previous file",
  "filePreview.next": "Next file",
  "filePreview.loading": "Loading file...",
  "filePreview.pdfLoading": "Loading PDF...",
  "filePreview.pdfLoadFailed": "Could not preview the PDF. Try again or download it",
  "filePreview.retry": "Retry",
  "filePreview.downloadFile": "Download file",
  "filePreview.zoomOutPdf": "Zoom out PDF",
  "filePreview.zoomInPdf": "Zoom in PDF",
  "filePreview.videoLoading": "Loading video...",
  "filePreview.videoUnsupported":
    "This browser does not support the video format or codec",
  "filePreview.downloadVideo": "Download video",
  "filePreview.openNewWindow": "Open in new window",
  "filePreview.loadFailed":
    "Could not load the file. Close the preview and try again",
  "filePreview.dragToMove": "Drag to move the preview window",
  "filePreview.videoToolbar": "Video preview tools",
  "filePreview.imageToolbar": "Image preview tools",
  "filePreview.rotateLeft": "Rotate left",
  "filePreview.rotateRight": "Rotate right",
  "filePreview.zoomOutVideo": "Zoom out of video",
  "filePreview.zoomOutImage": "Zoom out of image",
  "filePreview.resetVideo": "Reset video view",
  "filePreview.resetImage": "Reset image view",
  "filePreview.zoomInVideo": "Zoom in on video",
  "filePreview.zoomInImage": "Zoom in on image",
  "filePreview.unknownFile": "Unknown file",
  "filePreview.imageMode": "Image controls",
  "filePreview.videoMode": "Video controls",
  "filePreview.documentMode": "Document controls",
  "filePreview.noFile": "No file available for preview",
  "filePreview.addressFailed": "Could not get the file URL",
});

// 文件库
export const library = Object.freeze({
  "uploadLibrary.associationAll": "All",
  "uploadLibrary.associationLinked": "Linked",
  "uploadLibrary.associationUnlinked": "Unlinked",
  "uploadLibrary.allFiles": "All files",
  "uploadLibrary.recent": "Recently used",
  "uploadLibrary.ungrouped": "Ungrouped",
  "uploadLibrary.images": "Images",
  "uploadLibrary.videos": "Videos",
  "uploadLibrary.documents": "Documents",
  "uploadLibrary.previewUnavailable":
    "No preview URL is available for this file",
  "uploadLibrary.typeNotAllowed":
    "This file type is not allowed for the current upload",
  "uploadLibrary.sizeExceeded":
    "This file exceeds the current upload size limit",
  "uploadLibrary.enterGroupName": "Enter a group name",
  "uploadLibrary.newGroup": "New group",
  "uploadLibrary.groupNameRequired": "Group name is required",
  "uploadLibrary.groupCreated": "Group created",
  "uploadLibrary.deleteGroupConfirm":
    'Delete group "{name}"? Its files will move to Ungrouped; no files will be deleted.',
  "uploadLibrary.deleteGroup": "Delete group",
  "uploadLibrary.groupDeleted":
    "Group deleted. Its files were moved to Ungrouped",
  "uploadLibrary.chooseFile": "Select a file to upload",
  "uploadLibrary.unsupportedType": "{name}: unsupported file type",
  "uploadLibrary.maxFileSize": "{name}: file size must not exceed {size} MB",
  "uploadLibrary.fileUploadFailed": "{name}: upload failed",
  "uploadLibrary.missingFileRecord":
    "{name}: the server did not return a valid file record",
  "uploadLibrary.uploadFailed": "Upload failed",
  "uploadLibrary.uploadSuccess":
    "Uploaded {count} files. Switched to All files and selected them",
  "uploadLibrary.uploadFailedCount": "{count} file uploads failed: {reason}",
  "uploadLibrary.filesMoved": 'Moved {count} files to "{name}"',
  "uploadLibrary.deleteFilesConfirm":
    "Delete the {count} selected unlinked files? Linked files cannot be deleted.",
  "uploadLibrary.deleteFiles": "Delete files in bulk",
  "uploadLibrary.deleteSummary":
    "Deleted {deleted} files; skipped {skipped} files",
  "uploadLibrary.refreshAndRetry": "Refresh the page and try again",
  "uploadLibrary.deleteFailedReason": "{message}; {reason}",
  "uploadLibrary.deleteSkippedReason": "{message}. Reason: {reason}",
  "uploadLibrary.selectionLimit":
    "You can select up to {count} files for this upload",
  "uploadLibrary.privateFileNotAllowed":
    "This private file cannot be used for the current public listing. Select a file you can use",
  "uploadLibrary.selectionUnavailable":
    "Some files are unavailable or you do not have permission to use them. Select your own files again",
  "uploadLibrary.selectFile": "Select files",
  "uploadLibrary.selectType": "Select {type}",
  "uploadLibrary.filter": "Filter",
  "uploadLibrary.searchAllGroupFiles": "Search file names across all groups",
  "uploadLibrary.searchFileNames": "Search all file names",
  "uploadLibrary.search": "Search",
  "uploadLibrary.localBulkUpload": "Upload local files in bulk",
  "uploadLibrary.localUpload": "Upload files",
  "uploadLibrary.maxImagesPerGroup": "Up to 100 images per group",
  "uploadLibrary.selectPage": "Select this page",
  "uploadLibrary.batchManage": "Bulk actions",
  "uploadLibrary.group": "Move to group",
  "uploadLibrary.delete": "Delete",
  "uploadLibrary.selectedPrefix": "Selected",
  "uploadLibrary.selectedNoticeTail": "files. Confirm or manage the selection",
  "uploadLibrary.selectedFilesTail": "files",
  "uploadLibrary.selectFilesHint":
    "Select files to confirm or manage them in bulk",
  "uploadLibrary.clearSelection": "Clear selection",
  "uploadLibrary.deletionProgress":
    "Processing {processed}/{total}; deleted {deleted}; skipped {skipped}",
  "uploadLibrary.selectNamedFile": "Select file: {name}",
  "uploadLibrary.previewImage": "Preview image",
  "uploadLibrary.previewVideo": "Preview video",
  "uploadLibrary.previewFile": "Preview file",
  "uploadLibrary.preview": "Preview",
  "uploadLibrary.noRecentFilesPc":
    "No recently used files. Create or select a group first",
  "uploadLibrary.noRecentFilesMobile":
    "No recently used files. Select or upload one in All files",
  "uploadLibrary.noMatchingFiles": "No matching files",
  "uploadLibrary.noFiles": "No files",
  "uploadLibrary.batchGroup": "Move files to a group",
  "uploadLibrary.selectTargetGroupTail": "files; select a target group",
  "uploadLibrary.searchGroups": "Search group names",
  "uploadLibrary.targetGroup": "Target group",
  "uploadLibrary.noMatchingGroups":
    "No matching groups. Change the search or create a group",
  "uploadLibrary.noGroups": "No groups yet. Create one above",
  "uploadLibrary.groupChangeImmediate":
    "Group changes take effect immediately after saving.",
  "uploadLibrary.cancel": "Cancel",
  "uploadLibrary.confirm": "Confirm",
  "uploadLibrary.confirmSelection": "Confirm selection",
  "uploadLibrary.confirmSelectionCount": "Confirm selection ({count})",
  "uploadLibrary.filePagination": "File pages",
  "uploadLibrary.totalFiles": "{count} files",
  "uploadLibrary.previousPage": "Previous",
  "uploadLibrary.nextPage": "Next",
  "uploadLibrary.filterFiles": "Filter files",
  "uploadLibrary.fileGroups": "File groups",
  "uploadLibrary.deleteNamedGroup": "Delete group: {name}",
  "uploadLibrary.associationStatus": "Association status",
  "uploadLibrary.reset": "Reset",
  "uploadLibrary.selectFilePrompt": "Select files",
});

// 缩略图
export const thumbnail = Object.freeze({
  "uploadThumbnail.pdfCover": "PDF first-page cover",
  "uploadThumbnail.textSummary": "File content preview",
  "uploadThumbnail.loading": "Loading cover",
  "uploadThumbnail.unavailable": "Cover unavailable",
  "uploadThumbnail.formatCover": "File format cover",
  "uploadThumbnail.firstPage": "Page 1",
  "uploadThumbnail.summary": "Content preview",
  "uploadThumbnail.videoCover": "Video cover",
  "uploadThumbnail.videoFailed": "Unable to generate video cover",
  "uploadThumbnail.videoLoading": "Loading video cover",
  "uploadThumbnail.groupName": "Group name",
  "uploadThumbnail.deleteCount": "Delete {count} files?",
  "uploadThumbnail.irreversible": "Deleted files cannot be restored.",
  "uploadThumbnail.skipCount":
    "Another {count} linked files or files with unknown status will be skipped.",
});

export const attachmentUi = Object.freeze({
  "attachmentUi.maxFiles": "You can upload up to {count} files",
  "attachmentUi.fileSizeLimit": "{name} exceeds the {size}MB size limit",
  "attachmentUi.unsupportedFile": "Unsupported file type: {name}",
  "attachmentUi.remainingFiles":
    "You can upload up to {count} files; {remaining} more allowed",
  "attachmentUi.fileRejectionReason": "Rejection reason: {reason}",
  "attachmentUi.originalTemplateHint": "Upload the original contract template",
  "attachmentUi.singleStampedHint": "Upload the version stamped by one party",
  "attachmentUi.doubleStampedHint":
    "Upload the version stamped by both parties",
  "attachmentUi.tradeContractFiles": "Trade contract files",
  "attachmentUi.piFiles": "PI files",
  "attachmentUi.ciFiles": "CI files",
  "attachmentUi.templateContractFiles": "Contract template files",
  "attachmentUi.singleStampedFiles": "Single-stamped contract files",
  "attachmentUi.doubleStampedFiles": "Double-stamped contract files",
  "attachmentUi.viewNamedFile": "View {name}",
  "attachmentUi.uploadNamedFile": "Upload {name}",
  "attachmentUi.deleteNamedItem": "Delete {name}",
  "attachmentUi.rejectedPrefix": "Rejected: ",
  "attachmentUi.documents": "Documents",
  "attachmentUi.rejectionHint": "Rejected. View the reason",
  "attachmentUi.viewReason": "View reason",
  "attachmentUi.upload": "Upload",
  "attachmentUi.stamp": "Stamp",
  "attachmentUi.noRejectionReason": "No rejection reason provided",
  "attachmentUi.removeAttachment": "Remove attachment",
  "attachmentUi.fileTooLarge": "{name} exceeds 10MB and cannot be uploaded",
  "attachmentUi.fileUploaded": "{name} uploaded",
  "attachmentUi.downloadFailed": "Unable to download {name}",
});

export const sharedFlowUi = Object.freeze({
  "attachmentUi.uploadFailed": "Unable to upload the attachment",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...attachmentUi,
  ...preview,
  ...library,
  ...thumbnail,
});
